export default "__VITE_ASSET__5rgeuWCE__"